/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const CONTAINER_STORAGE_FIELD_KEYS = {
  list: 'containerStorage.list',
} as const;

export const CONTAINER_STORAGE_FIELD_KEY_LIST = [CONTAINER_STORAGE_FIELD_KEYS.list] as const;

export const CONTAINER_STORAGE_ACTION_KEYS = {
  addClaimTemplate: 'containerStorage.addClaimTemplate',
  addMountVolume: 'containerStorage.addMountVolume',
  edit: 'containerStorage.edit',
  remove: 'containerStorage.remove',
} as const;

export const CONTAINER_STORAGE_ACTION_KEY_LIST = [
  CONTAINER_STORAGE_ACTION_KEYS.addClaimTemplate,
  CONTAINER_STORAGE_ACTION_KEYS.addMountVolume,
  CONTAINER_STORAGE_ACTION_KEYS.edit,
  CONTAINER_STORAGE_ACTION_KEYS.remove,
] as const;
